// @flow

import styled from 'styled-components';

export const PageContainer = styled.div`
  max-width: 420px;
  margin: 0 auto;
  min-height: 100vh;
  overflow-y: auto;
  background: ${props => props.theme.colors.neutral.white};
  font-family: ${props => props.theme.fontFamily.sansSerif};
`;
